<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
              <PageHeader :title="title" :items="items"/>
                <b-card>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="name">Name</label>
                                <input v-model="search_data.name" type="text" class="form-control form-control-sm"
                                       placeholder="Search by Name" id="name"/>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-4">
                                <label class="col-form-label col-form-label-sm" for="ep_id">EP ID</label>
                                <input v-model="search_data.ep_id" type="text" class="form-control form-control-sm"
                                       placeholder="Search by EP ID" id="ep_id"/>
                            </div>
                          <div class="col-md-6 col-sm-6 col-lg-4">
                            <label class="col-form-label col-form-label-sm" for="mouza_id">Mouza</label>
                            <select v-model="search_data.mouza_id" class="form-control form-control-sm" name="mouza_id" id="mouza_id">
                              <option selected :value="''">Select a Mouza</option>
                              <option v-for="(mouza, index) in mouzas" :key="index" :value="mouza.id">{{ mouza.id }} : {{ mouza.mouza_desc }}</option>
                            </select>
                          </div>
                        </div>
                        <button class="btn btn-success btn-sm mt-2" @click.prevent="search">Search</button>
                    </form>
                </b-card>

                <b-card>
                    <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th>EP ID</th>
                                <th>Name</th>
                                <th>Father's Name</th>
                                <th>National ID</th>
                                <th>Mobile Number</th>
                                <th>Mouza</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(ses, index) in seses.data" :key="index">
                                <td>{{ seses.from + index }}</td>
                                <td><span v-if="(ses.ep_id !== null)">{{ epIdWithPaymentStatus(ses.ep_id.ep_id, ses.ep_id.is_paid) }}</span></td>
                                <td>
                                    <router-link :to="{ name: 'sesView',params: { ses_id: ses.id }}" tag="a"
                                                 target="_blank">{{ ses.name }}
                                    </router-link>
                                </td>
                                <td>{{ ses.father_husband_name }}</td>
                                <td>{{ ses.nid }}</td>
                                <td>{{ ses.mobile }}</td>
                                <td>{{ ses.mouza ? ses.mouza.mouza_desc : '' }}</td>
                                <td>
                                    <span v-if="(ses.ep_id !== null && ses.ses_power_groups.length === 0)">
                                        <a v-if="userPermission.includes('ses-power-group-create')"  @click.prevent="addPowerGroupModal(ses.id, ses.ep_id.ep_id, ses.name)" class="action-icon"
                                           href="javascript:void(0);" title="Create Power Group">
                                            <i class="mdi mdi-plus-box addButton"></i>
                                        </a>
                                    </span>

                                   <span v-else>
                                        <router-link v-if="userPermission.includes('ses-power-group-list')"  :to="{ name: 'sesPowerGroupList', params: { ses_id: ses.id } }"
                                                     tag="a" target="_blank">Add/Edit
                                    </router-link>
                                   </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <div v-if="loader" class="loader">Loading...</div>
                        <h5 class="text-center text-secondary" v-if="seses.total === 0 || !flag">
                          No Data Found
                        </h5>
                        <div class="float-right mt-2">
                            <pagination :data="seses" :limit="2" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>
        <create-power-group-modal
                :ses_power_group="ses_power_group"
                @search="search">
        </create-power-group-modal>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    import createPowerGroupModal from "@views/data/modals/createPowerGroupModal";
    import { epIdWithPaymentStatus } from '@/src/utils/format-epid'

    export default {
        page: {
            title: "EP List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, createPowerGroupModal},
        data() {
            return {
                title: "Search EP",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "EP List",
                        active: true
                    }
                ],
                seses: {},
                ses_power_group: {},
                search_data: {
                  name: '',
                  ep_id: '',
                  mouza_id: '',
                },
                mouzas: [],
                btn_edit: false,
                flag: false,
                loader: false
            };
        },

        mounted() {
          this.getCodes();
        },
        methods: {
            epIdWithPaymentStatus: epIdWithPaymentStatus,
            search() {
                this.flag = true
                this.loader = true
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http.post("api/ses/power/group/search", this.search_data).then(response => {
                            if (!response.error) {
                                this.flag = true;
                                this.loader = false
                                this.seses = response.data.seses;
                            }
                        });
                    }
                });
            },
            getResults(page = 1) {
                this.flag = true
                this.loader = true
                http.post('api/ses/power/group/search?page=' + page, this.search_data)
                    .then(response => {
                        this.flag = true;
                        this.loader = false
                        this.seses = response.data.seses;
                    });
            },
            addPowerGroupModal(ses_id, ep_id, name) {
                this.ses_power_group = {};
                this.ses_power_group.ses_id = ses_id;
                this.ses_power_group.ep_id = ep_id;
                this.ses_power_group.name = name;
                this.$root.$emit("bv::show::modal", "create-power-group");
            },
          getCodes() {
            http.get("api/ses/power/group/codes").then(response => {
              if (!response.error) {
                let data = response.data;
                this.mouzas = data.mouzas;
              }
            });
          },
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
<style src="vue-select/dist/vue-select.css"></style>
